


















































import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { User } from "@/types";
import { collections } from "@/configs/firebase";
import { Routes } from "@/router/routes";
import logger from "@/configs/logger";
import { Howl } from "howler";
import { spawnNotification } from "@/helpers";

@Component
export default class PendingVerificationModal extends Vue {
  @State("user") user!: User;

  tone = new Howl({
    src: [require("@/assets/sounds/ToneNotification0.mp3")],
    loop: false,
    autoplay: false,
    html5: true,
    onload: () => {
      logger("log", "bug sound loaded");
    },
    onloaderror: (soundId: number, error: any) => {
      logger("error", `bug sound error ${soundId}`, error);
    },
    onplay: () => {
      logger("log", "bug sound play");
    },
    onplayerror: (soundId: number, error: any) => {
      logger("error", `bug sound play error ${soundId}`, error);
    },
    onend: () => {
      logger("log", "bug sound ended");
    }
  });

  initialUpdate = true;
  pendingVerifications = 0;
  activeModalName = "";
  lead: any = {};
  unsubscribeVer = () => {};

  get closer() {
    if (this.lead.last_agent_email_by_role) {
      return this.lead.last_agent_email_by_role.closer;
    }
    return "";
  }

  mounted() {
    this.observeVerification();
  }

  beforeDestroy() {
    this.unsubscribeVer && this.unsubscribeVer();
  }

  closeModal() {
    this.$modal.hide(this.activeModalName);
  }

  openVerification() {
    this.$router.push({ name: Routes.Verification }).then(this.closeModal);
  }

  observeVerification(): void {
    if (
      this.user &&
      this.user.roles &&
      this.user.roles.includes("verification")
    ) {
      this.unsubscribeVer();

      this.unsubscribeVer = collections.lead
        .where("verification_requested", "==", true)
        .where("verification_completed", "==", false)
        .orderBy("verification_requested_ts", "desc")
        .onSnapshot(snapshot => {
          if (this.$route.name == Routes.Verification) {
            return;
          }
          if (this.initialUpdate) {
            // on first snapshot all documents will be in the list
            this.pendingVerifications = snapshot.size;
            if (this.pendingVerifications > 0) {
              this.$modal.show("verification_dialog_all");
              this.activeModalName = "verification_dialog_all";
            }
          } else {
            const doc = snapshot.docChanges()[0];
            if (doc.type == "added") {
              const lead = doc.doc.data();
              logger("log", "verification requested:", lead);
              this.lead = lead;
              this.$modal.show("verification_dialog_single");
              this.tone.play();
              if (!document.hasFocus()) {
                spawnNotification("Verification has been requested");
              }
              this.activeModalName = "verification_dialog_single";
            }
          }
          this.initialUpdate = false;
        });
    }
  }
}
